
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/candle",
      function () {
        return require("private-next-pages/candle.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/candle"])
      });
    }
  